import React from 'react';
import { Switch, Route, Redirect, useRouteMatch } from 'react-router-dom';

import { ContentProvider } from './context/ContentContext';
import ContentLayout from './components/ContentLayout';
import ModuleForm from './components/ModuleForm';
import VideoForm from './components/VideoForm';
import ExerciseForm from './components/ExerciseForm';
import QuizForm from './components/QuizForm';
import AttachmentForm from './components/AttachmentForm';

/**
 * Cadastro de Conteúdo em sub-rotas: cada tipo de conteúdo tem URL própria
 * (`/admin/add-course-video/video`, `/exercise`, ...), e o curso escolhido
 * persiste em `?courseid=` entre elas.
 */
const AdminAddVideo: React.FC = () => {
  const { path } = useRouteMatch();

  return (
    <ContentProvider>
      <ContentLayout>
        <Switch>
          <Route path={`${path}/module`} component={ModuleForm} />
          <Route path={`${path}/video`} component={VideoForm} />
          <Route path={`${path}/exercise`} component={ExerciseForm} />
          <Route path={`${path}/quiz`} component={QuizForm} />
          <Route path={`${path}/materials`} component={AttachmentForm} />
          <Redirect to={`${path}/video`} />
        </Switch>
      </ContentLayout>
    </ContentProvider>
  );
};

export default AdminAddVideo;
